'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('density', {
      url: '/account/density',
      template: '<density></density>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/density/density.routes.js